'use client';

import React, { useEffect } from 'react';

interface AdSenseUnitProps {
  adSlot: string;
  adFormat?: 'auto' | 'fluid' | 'rectangle' | 'horizontal' | 'vertical';
  adLayout?: string;
  className?: string;
  style?: React.CSSProperties;
  isResponsive?: boolean;
}

const AdSenseUnit: React.FC<AdSenseUnitProps> = ({
  adSlot,
  adFormat = 'auto',
  adLayout,
  className = '',
  style = {},
  isResponsive = true,
}) => {
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  return (
    <div data-component-id="src/components/common/AdSenseUnit.tsx:33:4" data-component-path="src/components/common/AdSenseUnit.tsx" data-component-line="33" data-component-end-line="55" data-component-file="AdSenseUnit.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" 
      className={`adsense-container ${className}`} 
      style={{ 
        minHeight: '280px',
        minWidth: '250px',
        width: '100%',
        ...style 
      }}
    >
      <ins data-component-id="src/components/common/AdSenseUnit.tsx:42:6" data-component-path="src/components/common/AdSenseUnit.tsx" data-component-line="42" data-component-end-line="54" data-component-file="AdSenseUnit.tsx" data-component-name="ins" data-component-content="%7B%22elementName%22%3A%22ins%22%2C%22className%22%3A%22adsbygoogle%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        className="adsbygoogle"
        style={{ 
          display: 'block', 
          minHeight: '250px',
          width: '100%',
        }}
        data-ad-client="ca-pub-8486674707710963"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        {...(adLayout && { 'data-ad-layout': adLayout })}
        data-full-width-responsive={isResponsive ? 'true' : 'false'}
      />
    </div>
  );
};

export default AdSenseUnit;